import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { BrandIdentity } from '../models/brandIdentity';

export const onGetBrandIdentity = async () => {
	try {
		const response = await axios.get<JsonResponse<BrandIdentity>>('dashboard/brand-identity');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onUpdateBrandIdentity = async (data: FormData) => {
	try {
		const response = await axios.post(`dashboard/brand-identity`, data, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
